// test1661
(1661 && 0);
